@if (control) {
  <div class="otp-form-group" [formGroup]="parentForm">
    <div
      class="otp-inputs"
      [class.otp-inputs-invalid]="showErrorState"
      [class.otp-inputs-disabled]="isDisabled"
    >
      @for (digit of digits; track $index) {
        <input
          #otpInput
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          maxlength="1"
          class="otp-digit"
          [value]="digit"
          [disabled]="isDisabled"
          [attr.aria-label]="'otp-digit-' + ($index + 1)"
          [attr.autocomplete]="$index === 0 ? 'one-time-code' : 'off'"
          (input)="onDigitInput($index, $event)"
          (keydown)="onKeyDown($index, $event)"
          (paste)="onPaste($index, $event)"
          (focus)="onFocus($event)"
          (blur)="onBlur()"
        />
      }
    </div>

    @if (externalErrorMessage) {
      <div class="otp-error-message">
        <span>{{ externalErrorMessage }}</span>
      </div>
    } @else if (showBuiltInErrors) {
      <div class="otp-error-message">
        @if (control.errors?.required) {
          <span>{{ control.requiredErrorMessage }}</span>
        }

        @if (control.errors?.pattern || control.errors?.incorrect) {
          <span>{{ control.incorrectErrorMessage }}</span>
        }
      </div>
    }
  </div>
}